import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

interface ShowAndHideOtpProps {
    password: string;
    setPassword: (value: string) => void;
    containerStyles?: string;
}

export const ShowAndHideOtp = ({ password, setPassword, containerStyles }: ShowAndHideOtpProps) => {
    const [visible, setVisible] = useState(false);


    return (
        <div
            className={`w-full mb-5 relative flex flex-row bg-melon-light-grey rounded-lg h-12 text-center  ${containerStyles}`}>
            <input
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={visible ? "text" : "password"}
                placeholder='OTP-код*'
                className="bg-melon-light-grey rounded-lg h-12 text-center w-full focus:outline-none text-melon-black "
            />
            <div onClick={() => setVisible(!visible)}
                className=" absolute right-0 p-4 flex justify-between items-center cursor-pointer">
                {visible ? <FaEye color="black" /> : <FaEyeSlash color="black" />}
            </div>
        </div>
    )
}
